import projectRecipesApp from './images-projects/imagem-recipes-app.png';
import projectTFC from './images-projects/image-tfc.png'; 
import projectPort from './images-projects/image-port.png';
import projectStore from './images-projects/imagem-kabuy.png';

const projects = [
    {
        image: projectRecipesApp,
        screen: 'mobile-img',
        projectName: 'Recipes App (Mobile)',
        subTitle: 'Front-end',
        description: 'Receitas App é um aplicativo mobile que permite acessar uma ampla variedade de receitas, incluindo refeições e drinks. Com ele, você pode pesquisar por nome de alimentos e nome de receitas.',
        skills: ['JavaScript', 'React', 'CSS', 'BrowserRouter', 'ContextAPI', 'RTL', 'Redux', 'Bootstrap'],
        Rlink: 'https://github.com/ebionarduche/App-De-Receitas-Mobile',
        Plink: 'https://app-de-receitas-psi.vercel.app/',
    },
    {
        image: projectStore,
        screen: 'desktop-img',
        projectName: 'Online Store (Em Desenvolvimento)',
        subTitle: 'Full-Stack',
        description: 'Este  projeto que cria uma plataforma de e-commerce, com todas as funcionalidades de um marketplace. O sistema proporciona aos usuários acesso a uma ampla gama de produtos, detalhes sobre os itens, a capacidade de adicionar produtos ao carrinho de compras, uma página para favoritos, histórico de compras e a possibilidade de adicionar seus próprios produtos à plataforma.',
        skills: ['JavaScript', 'TypeScript', 'React', 'CSS', 'ContextAPI', 'Axios', 'Node.Js', 'Express', 'MySql', 'Sequelize', 'Docker', 'POO' ],
        Rlink: 'https://github.com/ebionarduche/online-store',
    },
    {
        image: projectTFC,
        screen: 'desktop-img',
        projectName: 'Table Futebol Club',
        subTitle: 'Back-end',
        description: 'Este projeto inclui uma API desenvolvida em Node.js que permite criar, editar, excluir e selecionar partidas.',
        skills: ['TypeScript', 'NodeJs', 'POO', 'Sequelize', 'MySql', 'Sinon', 'Mocka', 'Docker', 'JWT' ],
        Rlink: 'https://github.com/ebionarduche/TFC',
        Plink: null,
    },
    {
        image: projectPort,
        screen: 'desktop-img',
        projectName: 'Portfolio',
        subTitle: 'Front-end',
        description: 'Aqui está o mesmo portfólio que encontramos agora. Seu código foi um dos mais recentes que escrevi, então ele tem toda uma evolução e organização que meus projetos antigos não tinham, por isso julgo interessante colocá-lo aqui.',
        skills: ['JavaScript', 'React', 'CSS', 'ContextAPI' ],
        Rlink: 'https://github.com/ebionarduche/my-portfolio',
        Plink: 'my-portfolio-ebionarduche.vercel.app/',
    },
];

export default projects;
